/**
 * Templates interface wrapping precompiled-templates to allow for easy testing.
 */
define(function (require) {
    let precompiledTemplates = require('generated/tc/modules/precompiled-templates');
    return {
        read(name) {
            // eslint-disable-next-line dot-notation
            let template = precompiledTemplates['templates']['tc'][name];
            if (typeof template === 'undefined' && !!window.console) {
                // eslint-disable-next-line no-console
                console.error('Template unable to be loaded for name:', name);
            }
            return template;
        },
    };
});
